import React from 'react';

import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';
import { Icon } from '../Icon';
import { merge } from '../../helpers/classes';

export type LoadingSpinnerProps = {
  cn?: string;
};

/**
 *
 */
export function LoadingSpinner({ cn = '' }: LoadingSpinnerProps) {
  const className = merge('text-lg inline-flex', cn);

  return (
    <div className={className} data-testid="loading-spinner">
      <div className="animate-spin">
        <Icon icon={faSpinnerThird} />
      </div>
    </div>
  );
}
